lmApp
  .directive('lmApplicationOttWeb', [
    function () {
      return {
        templateUrl: 'lm-showcase/application-ott-web/application-ott-web.tpl.html',
        restrict: 'E',
        replace: true,
        scope: {
          application: '=?',
          tab: '=?'
        },
        controller: ['$scope', '$rootScope', '$interval', '$templateCache', '$compile', 'ShowcaseService', 'ModalWindowService', 'ToastService', 'ApplicationService', 'ValidatorService',
          function ($scope, $rootScope, $interval, $templateCache, $compile, ShowcaseService, ModalWindowService, ToastService, ApplicationService, ValidatorService) {
            $scope.permissions = $rootScope.permissions;
            $scope.namespace = 'stockweb';
            $scope.newAlias = '';

            $scope.rnd = Date.now();

            $scope.$watch('application.background', function (newValue, oldValue) {
              if (newValue) {
                if ($scope.bgSlider) $interval.cancel($scope.bgSlider);

                if (!$scope.application.background) return;

                $scope.application.background.slider._PrivateData.currentItem = 0;
                $scope.bgSlider = $interval(function () {
                  if (!$scope.application.background.slider._PrivateData.isEdit) {
                    var len = $scope.application.background.slider.slider_items.length;
                    var next = $scope.application.background.slider._PrivateData.currentItem + 1;
                    $scope.application.background.slider._PrivateData.currentItem = (next < len) ? next : 0;
                  }
                }, 5000);

                $scope.application.background.slider.slider_items.forEach(function (item) {
                  item._PrivateData.filters = {};
                  item._PrivateData.searchResult = [];
                  item._PrivateData.selectedAsset = {};
                })
              }
            });

            $scope.$watch('application.banners', function (newValue, oldValue) {
              if (newValue) {
                if (!$scope.application.banners) return;

                $scope.application.banners._PrivateData._CSS = {
                  left: 0
                };

                $scope.application.banners._PrivateData.firstElement = 0;

                $scope.application.banners.slider.slider_items.forEach(function (item) {
                  item._PrivateData.filters = {};
                  item._PrivateData.searchResult = [];
                  item._PrivateData.selectedAsset = {};
                })
              }
            });

            $scope.$watch('application.platform.logo_url', function (newValue, oldValue) {
              if (newValue !== oldValue) {
                ApplicationService.UpdatePlatform({logo_url: newValue, id: $scope.application.platform.id})
                  .then(function (response) {
                    $rootScope.hideLinearProgress('#showcasesLoader');
                    ToastService.Small({
                      title: 'App logo successfully updated',
                      color: 'green',
                      icon: 'image-area'
                    });
                  })
                  .catch(function (reason) {
                    $rootScope.hideLinearProgress('#showcasesLoader');
                    ToastService.Small({
                      title: 'App logo update failed',
                      color: 'red',
                      icon: 'image-area'
                    });
                    $rootScope.debugInfo(reason);
                  });
              }
            });

            $scope.isSuperuser = function () {
              return $rootScope.globals.currentUser && $rootScope.globals.currentUser.isSuperuser;
            };

            $scope.changeAppUrl = function (url) {
              ApplicationService.UpdatePlatform({app_url: url, id: $scope.application.platform.id})
                .then(function (response) {
                  $rootScope.hideLinearProgress('#showcasesLoader');
                  ToastService.Small({
                    title: 'App URL successfully changed',
                    color: 'green',
                    icon: 'dns'
                  });
                })
                .catch(function (reason) {
                  $rootScope.hideLinearProgress('#showcasesLoader');
                  ToastService.Small({
                    title: 'App URL change failed',
                    color: 'red',
                    icon: 'dns'
                  });
                  $rootScope.debugInfo(reason);
                });
            };

            $scope.createAlias = function (alias) {
              ApplicationService.CreateCNAME(alias)
                .then(function (response) {
                  $rootScope.hideLinearProgress('#showcasesLoader');
                  if (!$scope.application.aliases) $scope.application.aliases = []
                  $scope.application.aliases.push(alias);
                  $scope.application.newAlias = '';
                  ToastService.Small({
                    title: 'Alias successfully created',
                    color: 'green',
                    icon: 'dns'
                  });
                })
                .catch(function (reason) {
                  $rootScope.hideLinearProgress('#showcasesLoader');
                  ToastService.Small({
                    title: 'Alias create failed',
                    color: 'red',
                    icon: 'dns'
                  });
                  $rootScope.debugInfo(reason);
                });
            };

            $scope.deleteAlias = function (alias) {
              ApplicationService.RemoveCNAME(alias)
                .then(function (response) {
                  $rootScope.hideLinearProgress('#showcasesLoader');
                  for (var i = 0; i < $scope.application.aliases.length; i++) {
                    if ($scope.application.aliases[i] === alias) {
                      $scope.application.aliases.splice(i, 1);
                    }
                  }
                  ToastService.Small({
                    title: 'Alias successfully removed',
                    color: 'green',
                    icon: 'dns'
                  });
                })
                .catch(function (reason) {
                  $rootScope.hideLinearProgress('#showcasesLoader');
                  ToastService.Small({
                    title: 'Alias remove failed',
                    color: 'red',
                    icon: 'dns'
                  });
                  $rootScope.debugInfo(reason);
                });
            };

            $scope.editSlider = function (slider, currentItem) {
              if (!slider) return;

              var modalScope = $scope.$new();

              slider._PrivateData.isEdit = true;

              if (!_.isUndefined(currentItem) && currentItem > -1) slider._PrivateData.currentItem = currentItem;

              modalScope.isFirst = function () {
                return slider._PrivateData.currentItem === 0;
              };

              modalScope.isLast = function () {
                return !(slider._PrivateData.currentItem < slider.slider_items.length - 1);
              };

              modalScope.validate = {
                asset: function (item) {
                  var errors = {};

                  if (!item._PrivateData.title) {
                    errors.title = true;
                  }

                  if (!item._PrivateData.asset.id) {
                    errors.asset = true;
                  }

                  if (!item._PrivateData.picture) {
                    errors.picture = 'Required';
                  }

                  return item.errors = errors, errors;
                },

                external: function (item) {
                  var errors = {};

                  if (!item._PrivateData.title) {
                    errors.title = true;
                  }

                  if (!item._PrivateData.url || !ValidatorService.Url(item._PrivateData.url)) {
                    errors.url = 'Invalid URL format. Example: http://www.google.com';
                  }

                  if (!item._PrivateData.picture) {
                    errors.picture = 'Required';
                  }

                  return item.errors = errors, errors;
                }
              };

              modalScope.prevSlider = function (slider) {
                var prev = slider._PrivateData.currentItem - 1;
                slider._PrivateData.currentItem = (prev >= 0) ? prev : 0;
              };

              modalScope.nextSlider = function (slider) {
                var len = slider.slider_items.length;
                var next = slider._PrivateData.currentItem + 1;
                slider._PrivateData.currentItem = (next < len) ? next : next - 1;
              };

              modalScope.isSelectedAsset = function (item, asset) {
                return item._PrivateData.selectedAsset === asset;
              };

              modalScope.close = function (slider) {
                if (modalScope.loading) return;

                modalScope.fullscreenToogle(false);
                slider._PrivateData.isEdit = false;
                ModalWindowService.Close($scope.window, false);
              };

              modalScope.openSearch = function (item) {
                item._PrivateData.isSearch = true;
                item._PrivateData.filters.keyword = '';
              };

              modalScope.closeSearch = function (item) {
                item._PrivateData.isSearch = false;
              };

              modalScope.fullscreenToogle = function (state) {
                if (typeof state !== 'undefined') {
                  modalScope.fullscreen = state;
                } else {
                  modalScope.fullscreen = !modalScope.fullscreen;
                }

                ModalWindowService.Fullscreen($scope.window, state);
              };

              modalScope.addSliderItem = function (slider) {
                var newItem = {
                  title: '',
                  _PrivateData: {
                    widget_type: 'asset',
                    title: '',
                    filters: {},
                    searchResult: [],
                    picture: '',
                    originPicture: '',
                    asset: {},
                    url: '',
                    text: ''
                  },
                  isNew: true
                };

                slider._PrivateData.hasNewTile = true;

                slider.slider_items.push(newItem);
                slider._PrivateData.currentItem = slider.slider_items.length - 1;

                return slider;
              };

              modalScope.removeSliderItem = function (slider, index) {
                if (modalScope.loading) return;

                if (slider.slider_items[index].isNew) {
                  slider._PrivateData.hasNewTile = false;

                  slider.slider_items.splice(index, 1);
                  var newIndex = slider._PrivateData.currentItem - 1;
                  slider._PrivateData.currentItem = (newIndex < 0 ) ? 0 : newIndex;

                  return;
                }

                modalScope.loading = true;
                $rootScope.showLinearProgress('#showcasesLoader');

                var _ids = slider.slider_items
                  .filter(function (item, i) {
                    return i !== index;
                  })
                  .map(function (item) {
                    return item.id;
                  });

                ShowcaseService.UpdateSlider(slider, _ids)
                  .then(function (response) {
                    $rootScope.hideLinearProgress('#showcasesLoader');
                    modalScope.loading = false;
                    slider.slider_items.splice(index, 1);
                    var newIndex = slider._PrivateData.currentItem - 1;
                    slider._PrivateData.currentItem = (newIndex > 0) ? newIndex : 0;
                    ToastService.Small({
                      title: 'Slider item successfully deleted',
                      color: 'green',
                      icon: 'delete'
                    });
                  })
                  .catch(function (reason) {
                    $rootScope.hideLinearProgress('#showcasesLoader');
                    ToastService.Small({
                      title: 'Slider item delete failed',
                      color: 'red',
                      icon: 'delete'
                    });
                    modalScope.loading = false;
                    $rootScope.debugInfo(reason);
                  });
              };

              modalScope.processItem = function (data, item) {
                if (item.isNew) {
                  modalScope.createNewSliderItem(slider, item);
                } else {
                  modalScope.updateWidget(item);
                }
              };

              modalScope.createNewSliderItem = function (slider, item) {
                if (modalScope.loading) return;

                var promise;

                if (item._PrivateData.widget_type === 'asset') {
                  if (!_.isEmpty(modalScope.validate.asset(item))) {
                    return;
                  }

                  promise = ShowcaseService.CreateAssetWidget(item, $scope.namespace);
                } else if (item._PrivateData.widget_type === 'external') {
                  if (!_.isEmpty(modalScope.validate.external(item))) {
                    return;
                  }

                  promise = ShowcaseService.CreateExternalWidget(item, $scope.namespace);
                }

                modalScope.loading = true;
                $rootScope.showLinearProgress('#showcasesLoader');

                promise
                  .then(function (response) {
                    slider.slider_items[slider._PrivateData.currentItem].id = response.widget.id;
                    var _ids = slider.slider_items.map(function (item) {
                      return item.id;
                    });

                    item.isNew = false;
                    _.assign(item, response.widget);

                    return ShowcaseService.UpdateSlider(slider, _ids)
                      .then(function (response) {
                        slider._PrivateData.hasNewTile = false;

                        $rootScope.hideLinearProgress('#showcasesLoader');
                        modalScope.loading = false;
                        ToastService.Small({
                          title: 'Slider item successfully created',
                          color: 'green',
                          icon: 'view-carousel'
                        });
                        if (item._PrivateData.text) item.text = item._PrivateData.text;
                      })
                      .catch(function (reason) {
                        throw reason;
                      });

                  })
                  .catch(function (reason) {
                    ToastService.Small({
                      title: 'Slider item creation failed',
                      color: 'red',
                      icon: 'view-carousel'
                    });
                    modalScope.loading = false;
                    $rootScope.hideLinearProgress('#showcasesLoader');
                    $rootScope.debugInfo(reason);
                  });
              };

              modalScope.updateWidget = function (item) {
                if (modalScope.loading) return;

                var promise;
                if (item._PrivateData.widget_type === 'asset') {
                  if (!_.isEmpty(modalScope.validate.asset(item))) {
                    return;
                  }

                  promise = ShowcaseService.UpdateAssetWidget(item);
                } else if (item._PrivateData.widget_type === 'external') {
                  if (!_.isEmpty(modalScope.validate.external(item))) {
                    return;
                  }

                  promise = ShowcaseService.UpdateExternalWidget(item);
                }

                promise
                  .then(function (response) {
                    modalScope.loading = false;
                    $rootScope.hideLinearProgress('#showcasesLoader');
                    ToastService.Small({
                      title: 'Widget successfully updated',
                      color: 'green',
                      icon: 'view-carousel'
                    });
                    if (item._PrivateData.text && item.widget_attrs) item.widget_attrs.text = item._PrivateData.text;
                  })
                  .catch(function (reason) {
                    ToastService.Small({
                      title: 'Widget update failed',
                      color: 'red',
                      icon: 'view-carousel'
                    });
                    modalScope.loading = false;
                    $rootScope.hideLinearProgress('#showcasesLoader');
                    $rootScope.debugInfo(reason);
                  });
              };

              modalScope.selectAsset = function (item, asset) {
                item._PrivateData.selectedAsset = asset;
              };

              modalScope.addAssetToTile = function (item) {
                if (!item._PrivateData.selectedAsset) return;

                var asset = item._PrivateData.selectedAsset;

                item._PrivateData.searchResult = [];
                item._PrivateData.keyword = '';
                item._PrivateData.selectedAsset = {};

                item._PrivateData.asset = asset;

                if (!item._PrivateData.picture) {
                  var pictureResources = asset.resources && asset.resources.filter(function (resourse) {
                      return resourse.category === 'poster_blueprint';
                    });

                  if (pictureResources && pictureResources.length) {
                    item._PrivateData.picture = pictureResources[0].source;
                  }
                }

                item._PrivateData.asset.duration = parseInt(asset.duration / 60, 10);

                if (asset.genres) {
                  item._PrivateData.asset.genres = asset.genres.map(function (genre) {
                    return genre.title;
                  });
                }

                modalScope.closeSearch(item);
              };

              modalScope.data = slider;
              modalScope._tpl_ = $templateCache.get('lm-showcase/application-ott-web/edit-slider.tpl.html');

              modalScope._tpl_ = $compile(modalScope._tpl_)(modalScope);

              modalScope.slideReorder = function (slider, item, direction) {
                if (modalScope.loading) return;

                var index = slider.slider_items.indexOf(item);
                var swap = null;

                if (index !== -1 && index + direction >= 0 && index + direction < slider.slider_items.length) {
                  $rootScope.showLinearProgress('#showcasesLoader');
                  modalScope.loading = true;

                  swap = slider.slider_items[index + direction];
                  slider.slider_items[index + direction] = item;
                  slider.slider_items[index] = swap;

                  slider._PrivateData.currentItem += direction;

                  var _ids = _.map(slider.slider_items, 'id');

                  ShowcaseService.UpdateSlider(slider, _ids)
                    .then(function (response) {
                      modalScope.loading = false;

                      $rootScope.hideLinearProgress('#showcasesLoader');
                      ToastService.Small({
                        title: 'Slider\'s items successfully reordered',
                        color: 'green',
                        icon: 'view-carousel'
                      });
                    })
                    .catch(function (reason) {
                      modalScope.loading = false;
                      $rootScope.hideLinearProgress('#showcasesLoader');

                      throw reason;
                    });
                }
              };

              $scope.window = ModalWindowService.Open({
                content: modalScope._tpl_,
                clear: true,
                size: {
                  s: 10
                },
                onInit: function () {
                  if (currentItem === -1) modalScope.addSliderItem(slider);
                },
                onComplete: function () {
                  slider.slider_items.forEach(function (item, index) {
                    if (item.isNew) {
                      slider.slider_items.splice(index, 1);
                    }
                  });

                  slider._PrivateData.currentItem = 0;
                }
              });

              modalScope._tpl_.on('$destroy', function () {
                modalScope.$destroy();
              })
            };
          }],
        link: function (scope, element, attrs) {
          scope.slideLeft = function () {
            scope.application.banners._PrivateData.firstElement -= 1;
            if (scope.application.banners._PrivateData.firstElement < 0) {
              scope.application.banners._PrivateData.firstElement = 0;
            }
            scope.application.banners._PrivateData._CSS.left = '-' + (33.333 * scope.application.banners._PrivateData.firstElement) + '%';
          };

          scope.slideRight = function () {
            if (scope.application.banners._PrivateData.firstElement !== scope.application.banners.slider.slider_items.length - 2) {
              scope.application.banners._PrivateData.firstElement += 1;
              scope.application.banners._PrivateData._CSS.left = '-' + (33.333 * scope.application.banners._PrivateData.firstElement) + '%';
            }
          };
        }
      }
    }
  ]);
